/**
 * 字串行為參數的「產生」鈕（批151，裁示 112）。
 *
 * 憑證設計把某個字串行為參數標成「可產生唯一值」（`PolicySpec.generatable`）時，核發相關
 * 表單在那一格旁邊給一顆「產生」鈕，按下去填入 `YYYYMMDD-xxxx`：
 *
 * - `YYYYMMDD`＝操作者**本地**日期（不是 UTC——看得懂是哪天發的比跨時區一致更重要）；
 * - `xxxx`＝4 碼小寫十六進位，取自 `crypto.getRandomValues`（不用 `Math.random`）。
 *
 * ★ 只在按鈕被按下時產生，**不自動填**（裁示 112）；後端對這個旗標沒有任何行為，值的唯一性
 *   也不由 LS 保證——同一天同一個參數撞號的機率是 1/65536，用途是「發放編號」這類人看得懂、
 *   重複時產品端自己能處理的場合。
 */

/** 產生值的形狀（spec 與呼叫端驗證用）。 */
export const GENERATED_VALUE_RE = /^\d{8}-[0-9a-f]{4}$/

type FillRandom = (buf: Uint8Array) => Uint8Array

function defaultFill(buf: Uint8Array): Uint8Array {
  return globalThis.crypto.getRandomValues(buf)
}

function pad(n: number, width: number): string {
  return String(n).padStart(width, '0')
}

/**
 * 產生一個 `YYYYMMDD-xxxx`。`now`／`fill` 只給測試注入（日期固定、亂數固定）。
 */
export function generateUniqueValue(now: Date = new Date(), fill: FillRandom = defaultFill): string {
  const date = `${now.getFullYear()}${pad(now.getMonth() + 1, 2)}${pad(now.getDate(), 2)}`
  const bytes = fill(new Uint8Array(2))
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return `${date}-${hex}`
}
